import RotaCalenderComponent from "./RotaCalenderComponent";

export default function RotaManagementCalenderComponent() {
  return (
    <div>
      <RotaCalenderComponent />
    </div>
  );
}
